/**
 * Delegate description for subscription proxying
 */
export type SubscriptionHandler<TEmission> = (emitted: TEmission) => void;
